import { render, staticRenderFns } from "./FaxMessage.vue?vue&type=template&id=38139fbf&"
import script from "./FaxMessage.vue?vue&type=script&lang=js&"
export * from "./FaxMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\RobertWiberg\\source\\repos\\server-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38139fbf')) {
      api.createRecord('38139fbf', component.options)
    } else {
      api.reload('38139fbf', component.options)
    }
    module.hot.accept("./FaxMessage.vue?vue&type=template&id=38139fbf&", function () {
      api.rerender('38139fbf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Compose/Message/FaxMessage.vue"
export default component.exports